export default __webpack_public_path__ + "static/media/SMC 11.e4115333.pdf";